// Local development preview only. Public release still requires readiness review.
// Opt in when starting next dev; never use this flag as authentication.
export const EXPERIMENTS_AVAILABLE =
  process.env.NODE_ENV === "development" &&
  process.env.NEXT_PUBLIC_HENDERSON_EXPERIMENTS_PREVIEW === "1";
